exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-version{font-weight:500;color:#767676;font-size:15px}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/layout/footer/footer.component.scss"],"names":[],"mappings":"AAAA,aACC,gBAAgB,cACF,cACC,CACf","file":"footer.component.scss","sourcesContent":[".app-version {\n\tfont-weight: 500;\n\tcolor: #767676;\n\tfont-size: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/layout/footer/footer.component.scss
// module id = RjRy
// module chunks = 2